<script setup>
import HauptMenue from "../../components/HauptMenue.vue";
import FooterMenu from "../../components/FooterMenu.vue";
import DatenschutzHinweis from "../../components/DatenschutzHinweis.vue";
import DateInput from "../../components/DateInput.vue";
import ButtonSendDataSelfService from "../../components/ButtonSendDataSelfService.vue";
import ButtonResetServiceData from "../../components/ButtonResetServiceData.vue";
import CustomSelect from "../../components/CustomSelect.vue";
import Alertbox from "../../components/Alertbox.vue";
import ButtonBack from "../../components/ButtonBack.vue";
import { store } from "../../components/store.vue";
import { onMounted } from "vue";
import { ersterDesFolgemonats, diffObj } from "../../utility";

/** View-Komponente zum Erfassen von Aufträgen zum Firmenaustritt
 * @displayName Selfservice Auftrag Firmenaustritt
 */
onMounted(() => {
  // options with default values
  /*
  const options = {
    placement: "top",
    triggerType: "hover",
  };
  */
  // instance options with default values
});
</script>
<script>
export default {
  name: "SelfServiceFirmenaustritt",

  components: {
    // myRouter: router,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
    DateInput,
    ButtonSendDataSelfService,
    ButtonResetServiceData,
    CustomSelect,
    Alertbox,
    ButtonBack,
  },
  data() {
    return {
      store,
      saved: false,
      sPMNROptions: this.$servertalk.getVbPMNROpts(
        store.selfService.Firmenaustritt.ident
      ),
      sVersNrOptions: this.$servertalk.getVERSNROpts(
        store.selfService.Firmenaustritt.ident
      ),
      sGesellschaftsformOptions: this.$servertalk.getSelectOpts("GESFORM"),
      austrittsdatumOk:
        store.subData.draft.sService.Entwuerfe.Firmenaustritt.AUSTRITTSDATUM
          .length == 10,
      beitragBisOk:
        store.subData.draft.sService.Entwuerfe.Firmenaustritt.BEITRAGBIS
          .length > 0,
      draftOrigin: null,
      draftChanged: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
  },
  unmounted() {
    if (this.saved) {
      // Nach Beauftragung Service in Draft komplett löschen
      delete store.subData.olddraft.sService.Entwuerfe.Firmenaustritt;
      delete store.subData.draft.sService.Entwuerfe.Firmenaustritt;
      this.saved = false;
    }
  },
  beforeCreate: function () {
    this.$servertalk.doLog("Create");
    this.$servertalk.doLog("Inhalt store:");
    this.$servertalk.doLog(store);
    let action = this.$servertalk.initSelfService(
      "Firmenaustritt",
      '{"APANSPRNR":"", "PERSNR":"", "Vorname":"", "Nachname":"", "PMNR":"", "VERSNR":"","AUSTRITTSDATUM":"", "BEITRAGBIS":"", "BEMERKUNG":"", "uuid":"", "version":"1.5"}',
      "1.5",
      store.subData
    );
    // Ermitteln des Index des aktuellen Mitarbeiters in subData
    this.Mitarbeiter = store.xSelectedMitarbeiter;
    //if (action % 2 == 1) {
    // olddraft wurde initialisiert
    this.$servertalk.doLog("olddraft wurde initialisiert");
    let olddraft = store.subData.olddraft.sService.Entwuerfe.Firmenaustritt;
    olddraft.PERSNR = store.xSelectedMitarbeiter.PERSNR;
    olddraft.uuid = this.$servertalk.getUUID();

    //if (action >= 2) {
    this.$servertalk.doLog("draft wurde initialisiert");
    // draft wurde initialisiert
    this.$servertalk.copyToDraftSelfService("Firmenaustritt", store.subData);
    //  }
  },
  created: function () {
    // Erforderlich für Anzeige von Änderungsaufträgen.
    let draft = store.subData.draft.sService.Entwuerfe.Firmenaustritt;
    draft.APANSPRNR = store.masterData.data.Stammdaten.ANSPRNR;
    let _PMNR = this.$servertalk.getVbPMNR(
      store.selfService.Firmenaustritt.ident
    );
    draft.PMNR = "-"; // Es existiert keine PMNR
    if (_PMNR.length > 0) {
      draft.PMNR = _PMNR[0].PMNR; // Es existiert mindestens eine PMNR > die erste einstellen
      this.sVersNrOptions = this.$servertalk.getVERSNROpts(
        store.selfService.Firmenaustritt.ident,
        draft.PMNR,
        false
      );
      let _VERSNR = this.$servertalk.getVersicherungen(
        store.selfService.Firmenaustritt.ident,
        draft.PMNR,
        false
      );
      if (_VERSNR.length == 1) {
        draft.VERSNR = _VERSNR[0].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
      }
      if (_VERSNR.length > 1) {
        draft.VERSNR = 'alle';
      }
    }
    draft.AUSTRITTSDATUM = ersterDesFolgemonats();
    draft.BEITRAGBIS = ersterDesFolgemonats();
    draft.Vorname = this.Mitarbeiter.VORNAME;
    draft.Nachname = this.Mitarbeiter.NAME;
    this.draftOrigin = structuredClone(draft);
  },
  methods: {
    draftModified(oldData, draft) {
      this.draftChanged = false;
      if (typeof oldData != "undefined") {
        const dif = diffObj(this.draftOrigin, draft);
        this.draftChanged = Object.keys(dif).length > 0;
        this.$servertalk.doLog('dif: >>>', dif);
      }
    },
    austrittsdatumChecked(val) {
      this.austrittsdatumOk = val == "false" ? true : false;
    },
    beitragBisChecked(val) {
      this.beitragBisOk = val == "false" ? true : false;
    },
    setPMNR(val) {
      let draft = store.subData.draft.sService.Entwuerfe.Firmenaustritt;
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        draft.PMNR =
          val.value + "";
        //this.$forceUpdate(); // Erzwingt ein erneutes Rendern der Komponente
        this.sVersNrOptions = this.$servertalk.getVERSNROpts(
          store.selfService.Firmenaustritt.ident,
          draft.PMNR,
          false
        );
        let _VERSNR = this.$servertalk.getVersicherungen(
          store.selfService.Firmenaustritt.ident,
          draft.PMNR,
          false
        );
        if (_VERSNR.length == 1) {
          draft.VERSNR = _VERSNR[0].VERSNR; // Es existiert (genau) eine VERSNR > diese einstellen
        }
        if (_VERSNR.length > 1)
          draft.VERSNR = "alle"; // Es existieren mehrere VERSNRn > "alle" einstellen
      }
    },
    setVERSNR(val) {
      let draft = store.subData.draft.sService.Entwuerfe.Firmenaustritt;
      if (val && typeof val === "object" && typeof val.value !== "undefined") {
        if (this.sVersNrOptions.length > 1) {
          draft.VERSNR =
            val.value + "";
        } else {
          draft.VERSNR = 'alle';
        }
      }
    },
    sendDataFinished() {
      let messageCode = this.$servertalk.sendDataSelfService(
        "Firmenaustritt",
        store.subData
      );
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Firmenaustritt \n wurden erfolgreich beauftragt.",
            status: "ok",
          }
          : {
            text:
              "Beim Speichern des Auftrags im Bereich\n Firmenaustritt \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
      if (messageCode == 0) this.saved = true;
      this.$router.push("/mitarbeiterdaten");
    },
    resetData() {
      //this.$refs.SelectFamStand.reset(); // Zurücksetzen Select
      let messageCode = this.$servertalk.copyToDraftSelfService(
        "Firmenaustritt",
        store.subData
      );
      this.draftOrigin = structuredClone(store.subData.draft.sService.Entwuerfe.Firmenaustritt);
      store.message =
        messageCode == 0
          ? {
            text: "Ihre Änderungen im Bereich\n Firmenaustritt \n wurden zurückgesetzt.",
            status: "ok",
          }
          : {
            text:
              "Beim Zurücksetzen der Daten im Bereich\n Firmenaustritt \n trat ein Fehler auf (Error-Code " +
              messageCode +
              ").",
            status: "error",
          };
    }
  },
  watch: {
    "store.subData.draft.sService.Entwuerfe.Firmenaustritt": {
      handler(newData, oldData) {
        this.draftModified(
          oldData,
          store.subData.draft.sService.Entwuerfe.Firmenaustritt
        );
      },
      deep: true,
    },
  },
  computed: {
    getVersBeginn() {
      let draft = store.subData.draft.sService.Entwuerfe.Firmenaustritt;
      let dateVersBeg = false;
      let versNr = draft.VERSNR;
      let versNrn = this.$servertalk.getVERSNROpts(
        store.selfService.Firmenaustritt.ident,
        draft.PMNR,
        false
      );
      //console.log('#versOpt2',versNrn)

      let idxVersnr = versNrn.findIndex((nr) => nr.text == versNr);

      if (idxVersnr >= 0) {
        let _VERSNR = this.$servertalk.getVersicherungen(
          store.selfService.Firmenaustritt.ident,
          draft.PMNR
        );
        dateVersBeg = _VERSNR[idxVersnr].VERSBEG;
      }

      return dateVersBeg;
    },
    setSchwebendClass() {
      // Erhalte den Wert "Privatadresse" von $servertalk
      //const aenderung = this.$servertalk.gettAttr("fadata.Firmenstammdaten");
      //const aenderungPrivatadresseValue = this.$servertalk.gettAttr("subData.draft.sService.Entwuerfe.AenderungKontaktdaten");
      return null;
    },
    setStatusClass() {
      // Erhalte den Wert "Firmenaustritt" von $servertalk
      const AenderungFirmenaustrittdatenValue = this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt"
      );
      return AenderungFirmenaustrittdatenValue;
    },
    setStatusClassPMNR() {
      // Erhalte den Wert "PMNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt.PMNR"
      );
    },
    setStatusClassVERSNR() {
      // Erhalte den Wert "VERSNR" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt.VERSNR"
      );
    },
    setStatusClassBEMERKUNG() {
      // Erhalte den Wert "BEMERKUNG" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt.BEMERKUNG"
      );
    },

    setStatusClassAUSTRITTSDATUM() {
      // Erhalte den Wert "abDatum" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt.AUSTRITTSDATUM"
      );
    },
    setStatusClassBEITRAGBIS() {
      // Erhalte den Wert "abDatum" von $servertalk
      return this.$servertalk.gettAttr(
        "subData.draft.sService.Entwuerfe.Firmenaustritt.BEITRAGBIS"
      );
    },
    combinedFirmenstammdaten() {
      // Kombiniert FKENNR und FABRGR aus dem Store und trennt mit "/"
      const { FKENNR, FABRGR } = store.subData.data.Firmenstammdaten;
      return `${FKENNR || ""}/${FABRGR || ""}`;
    },
  },
};
</script>
<template>
  <div class="main-wrapper" :class="store.accessRestriction">
    <HauptMenue />
    <div>
      <div class="mt-36 md:mt-48 lg:mt-56 max-w-7xl mx-auto">
        <div class="max-w-5xl mx-auto mb-8 px-5 lg:px-0">
          <h1 class="text-primary/75 font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center mb-12 uppercase">
            Antrag Firmenaustritt für
            <br />
            <span>
              "{{ store.subData.data.Firmenstammdaten.FNAME }}
              {{
                $servertalk.getName(
                  "GESFORM",
                  store.subData.data.Firmenstammdaten?.FGESFORM
                )
              }}
              {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
                store.subData.data.Firmenstammdaten.FABRGR
              }}"
            </span>
            <br />
            <span>
              <h2 class="text-primary/75 font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-12">
                {{ store.xSelectedMitarbeiter.VORNAME }}
                {{ store.xSelectedMitarbeiter.NAME }}
                melden
              </h2>
            </span>
          </h1>
          <!--modal content-->
          <Alertbox />
          <div class="status-label mb-8" v-if="setStatusClass === 'modified'">
            <span class="bearbeitung bg-yellow-400 text-tertiary inline-block py-1 px-2 text-sm uppercase mb-2">
              Entwurf
            </span>
            <span class="infotext text-tertiary text-sm block">
              Dies ist ein Entwurf. Bitte bestätigen Sie diesen
              Änderungsauftrag, indem Sie unten auf
              <strong>Beauftragen</strong>
              klicken.
            </span>
          </div>
          <form :class="setStatusClass">
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <div v-if="sPMNROptions.length > 1">
                  <CustomSelect @input="setPMNR" class="select" :class="setStatusClassPMNR" required label="PMNR"
                    :options="sPMNROptions" :default="store.subData.draft.sService.Entwuerfe.Firmenaustritt.PMNR
                      " :oldDefault="store.subData.olddraft?.sService.Entwuerfe.Firmenaustritt
                        .PMNR
                        " hideReset="false" useArrowIcon="true" placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixPMNR" class="text-sm mb-2 block">PMNR</label>
                  <input id="fixPMNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassPMNR" type="text" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt.PMNR
                      " disabled />
                </div>
              </div>
              <div class="relative lg:col-span-6">
                <div v-if="sVersNrOptions.length > 1">
                  <CustomSelect class="select" @input="setVERSNR" :class="setStatusClassVERSNR"
                    label="Betroffene Versicherungen" :options="sVersNrOptions" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt
                      .VERSNR
                      " hideReset="false" useArrowIcon="true" disabledSub="true" placeholder="Keine" />
                </div>
                <div v-else>
                  <label for="fixVERSNR" class="text-sm mb-2 block">
                    Betroffene Versicherung
                  </label>
                  <input id="fixVERSNR"
                    class="w-full p-3 border rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 border-secondary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                    :class="setStatusClassVERSNR" type="text" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt
                      .VERSNR
                      " disabled />
                </div>
              </div>
            </div>
            <div class="grid lg:grid-cols-12 sm:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendVorname" class="text-sm mb-2 block">
                  Vorname der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendVorname"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.VORNAME" disabled="true" />
              </div>
              <div class="relative lg:col-span-6">
                <label for="aendName" class="text-sm mb-2 block">
                  Name der versicherten Person
                </label>
                <input maxlength="100" type="text" id="aendName"
                  class="peer w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500"
                  v-model="store.xSelectedMitarbeiter.NAME" disabled="true" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-6">
                <label for="aendAustrittsdatum" class="text-sm mb-2 block">
                  Austrittsdatum:
                  <sup>*</sup>
                </label>
                <DateInput :statusClass="setStatusClassAUSTRITTSDATUM" name="aendAustrittsdatum"
                  placeholder="gültiges Datum" id="aendAustrittsdatum" :required="true" :disabled="false"
                  :forceFirstOfNextMonth="true" :dmin="getVersBeginn" dmax="+730" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt
                    .AUSTRITTSDATUM
                    " @dateChecked="austrittsdatumChecked" :class="{ invalid: !austrittsdatumOk }" />
              </div>
              <div class="relative lg:col-span-6">
                <label for="aendBeitragBis" class="text-sm mb-2 block">
                  Zahlung Beitrag bis:
                  <sup>*</sup>
                </label>
                <DateInput :statusClass="setStatusClassBEITRAGBIS" name="aendBeitragBis" placeholder="gültiges Datum"
                  id="aendBeitragBis" :required="true" :disabled="false" :forceFirstOfNextMonth="true"
                  :dmin="getVersBeginn" dmax="+730" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt
                    .BEITRAGBIS
                    " @dateChecked="beitragBisChecked" :class="{ invalid: !beitragBisOk }" />
              </div>
            </div>
            <div class="grid lg:grid-cols-12 lg:gap-5">
              <div class="relative lg:col-span-12">
                <label for="aendBemerkung" class="text-sm mb-2 block">
                  Bemerkung
                </label>
                <textarea
                  class="w-full p-3 border border-secondary/50 rounded-md mb-8 invalid:border-red-500 invalid:bg-red-50 focus:outline-0 focus:border-tertiary/50 peer invalid:text-red-500 focus:invalid:border-red-500"
                  :class="setStatusClassBEMERKUNG" rows="5" v-model="store.subData.draft.sService.Entwuerfe.Firmenaustritt
                    .BEMERKUNG
                    "></textarea>
              </div>
            </div>
            <div class="button-wrapper flex justify-center gap-4 [&>button]:mx-0">
              <ButtonSendDataSelfService :disabled="store.subData.isReadOnly || !austrittsdatumOk || !beitragBisOk
                " @finished="sendDataFinished" />
            </div>
          </form>
          <ButtonBack :confirm="draftChanged" />
          <DatenschutzHinweis />
        </div>
      </div>
    </div>

    <FooterMenu />
  </div>
</template>
